import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" {...props}>
    <defs>
      <linearGradient id="facebook_svg__a" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#00C6FF" />
        <stop offset="100%" stopColor="#006EFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect
        width={24.028}
        height={24.028}
        x={0.055}
        fill="url(#facebook_svg__a)"
        rx={12.014}
      />
      <path
        fill="#FFF"
        d="m10.244 18.07-2.413 1.305v-2.498c-1.55-1.18-2.539-2.97-2.539-4.973 0-3.554 3.113-6.436 6.953-6.436 3.84 0 6.954 2.882 6.954 6.436 0 3.555-3.113 6.436-6.954 6.436a7.473 7.473 0 0 1-2-.27z"
      />
      <path
        fill="url(#facebook_svg__a)"
        d="m7.954 14.121 3.774-4.013 1.764 1.851 3.423-1.85-3.726 3.935-1.792-1.801z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgFacebook);
export default Memo;
